/**
 * We can't use `bowser.PLATFORMS_MAP` (https://github.com/bowser-js/bowser/blob/master/src/constants.js#L88)
 * here because it's defined as `Record<string, string>` and we can't rely on it, therefore, a more limited map was
 * defined below
 */
export const PLATFORM_TYPE = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
  TABLET: 'tablet',
  BOT: 'bot',
  TV: 'tv',
} as const;

/**
 * We can't use `bowser.OS_MAP` (https://github.com/bowser-js/bowser/blob/master/src/constants.js#L96) here
 * because it's defined as `Record<string, string>` and we can't rely on it, therefore, a more limited map was
 * defined below
 */
export const OS_TYPE = {
  WINDOWS_PHONE: 'Windows Phone',
  WINDOWS: 'Windows',
  MAC_OS: 'macOS',
  I_OS: 'iOS',
  ANDROID: 'Android',
  WEB_OS: 'WebOS',
  BLACK_BERRY: 'BlackBerry',
  BADA: 'Bada',
  TIZEN: 'Tizen',
  LINUX: 'Linux',
  CHROME_OS: 'Chrome OS',
  PLAY_STATION_4: 'PlayStation 4',
  ROKU: 'Roku',
} as const;

export const BROWSER_NAME = {
  MICROSOFT_EDGE: 'Microsoft Edge',
  CHROME: 'Chrome',
  FIREFOX: 'Firefox',
} as const;
